<template>
  <div>
    <div class="suporte">
      <div class="container suporte-container">
        <a href="https://i9educacao.edu.br" target="_blank"><img src="https://i9educacao.edu.br/assets/icons/home.svg"
            alt="Home">Página Inicial</a>
        <a href="https://i9educacao.edu.br/contact" target="_blank"><img
            src="https://i9educacao.edu.br/assets/icons/headset.svg" alt="Atendimento">Atendimento</a>
      </div>
    </div>
    <div class="navbar">
      <div class="container">
        <a href="https://i9educacao.edu.br" target="_blank">
          <img src="@/assets/logo.png" style="object-fit: contain;" width="180px" height="80px" alt="Logo i9 Educação">
        </a>
        <button class="hamburger" @click="toggleMenu">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </button>
        <div class="nav-itens" :class="{ 'nav-itens-active': isMenuOpen }">
          <a href="https://i9educacao.edu.br/course/list?tag=postgraduation" target="_blank">Pós-Graduação</a>
          <div class="nav-item" @mouseenter="showDropdown('posSocial')" @mouseleave="hideDropdown('posSocial')"
            @click="toggleDropdown('posSocial')">
            <a href="#">Pós Social <span class="arrow" :class="{ 'arrow-down': dropdowns.posSocial }">▼</span></a>
            <div class="submenu" v-if="dropdowns.posSocial">
              <a href="https://humanos.i9educacao.edu.br" target="_blank">Direitos Humanos</a>
              <a href="https://mulheres.i9educacao.edu.br" target="_blank">Direitos das Mulheres</a>
            </div>
          </div>
          <div class="nav-item" @mouseenter="showDropdown('extensaoI9')" @mouseleave="hideDropdown('extensaoI9')"
            @click="toggleDropdown('extensaoI9')">
            <a href="#">Extensão i9 <span class="arrow" :class="{ 'arrow-down': dropdowns.extensaoI9 }">▼</span></a>
            <div class="submenu" v-if="dropdowns.extensaoI9">
              <a href="https://i9educacao.edu.br/course/list?tag=formation" target="_blank">Formação i9</a>
              <a href="https://i9educacao.edu.br/course/list?tag=extension" target="_blank">Maratona i9</a>
              <a href="https://i9educacao.edu.br/course/list?tag=free" target="_blank">Cursos Grátis</a>
            </div>
          </div>
          <a href="https://i9play.com.br" target="_blank">i9Play</a>
          <div class="nav-item" @mouseenter="showDropdown('faculdade')" @mouseleave="hideDropdown('faculdade')"
            @click="toggleDropdown('faculdade')">
            <a href="#">A Faculdade <span class="arrow" :class="{ 'arrow-down': dropdowns.faculdade }">▼</span></a>
            <div class="submenu" v-if="dropdowns.faculdade">
              <a href="https://faculdade.i9educacao.edu.br" target="_blank">Institucional</a>
              <a href="https://faculdade.i9educacao.edu.br/nupeci/" target="_blank">NUPECI</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="avaliacao-final">
      <div class="container" style="
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
">
        <div class="title-avaliacao">
          <p><strong>Avaliação Final</strong> | Teste de Conhecimento</p>
        </div>
        <div class="timer">
          <span><img src="https://site-inove-bd2fd-homol.web.app/assets/icons/stopwatch-black.svg" alt="img"
              width="26px" height="30px" style="margin-right: 5px;">Tempo de Avaliação
            <span class="duracao-prova">{{ formatTime(timer) }}</span>
          </span>
        </div>
      </div>
    </div>
    <div v-if="showModal" class="modal-login">
      <div class="login-form">
        <h2>Insira seus dados, para prosseguir com o teste de conhecimento.</h2>
        <form @submit.prevent="registerUser">
          <div class="input-group-modal">
            <input type="text" id="nome" v-model="form.nome_completo" placeholder="Nome Completo" required>
          </div>
          <div class="input-group-modal">
            <input type="email" id="email" v-model="form.email" placeholder="E-mail" required>
            <input type="text" id="telefone" v-model="form.telefone" v-mask="'(##) #####-####'" placeholder="Telefone"
              required>
          </div>
          <div class="actions">
            <!--<button type="button" @click="closeModal">Cancelar</button>-->
            <button type="submit" :disabled="isLoading">Cadastre-se</button>
          </div>
          <div v-if="isLoading" class="loading-indicator">
            <i class="fas fa-spinner fa-spin"></i> Processando cadastro...
          </div>
          <div v-if="error" class="error">{{ error }}</div>
        </form>
      </div>
    </div>
    <div class="container pag-home">
      <div v-if="currentPage === 'home'">
        <div class="instrucoes-1">
          <span class="text-center informativo">Este teste é exclusivamente informativo, sem caráter avaliativo ou
            vínculo com a certificação final dos cursos
            oferecidos pela Faculdade i9 Educação.</span>
          <div class="row">
            <div class="col-md-6">
              <div class="video">
                <iframe src="https://www.youtube.com/embed/a_jwqVpZ6bw?si=TfH_9_S4OFGiKxsC" title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </div>
            <div class="col-md-6 orientacoes-atentamente">
              <div class="leia-atentamente">
                <img src="https://site-inove-bd2fd-homol.web.app/assets/icons/megaphone.svg" alt="Megafone">
                <p>LEIA ATENTAMENTE AS ORIENTAÇÕES ANTES DE REALIZAR A AVALIAÇÃO</p>
              </div>
              <div class="informacoes-prova">
                <ol>
                  <li>A avaliação final é composta por 10 (dez) questões de múltipla escolha com 04 (quatro)
                    alternativas
                    cada. Cada questão vale 1,0 (ponto).</li>
                  <li>Para obter aprovação na avaliação final, o aluno(a) deverá obter média igual ou superior a 7,0
                    (sete).
                  </li>
                  <li>A avaliação final terá a duração de 03 (três) horas que serão contadas a partir da abertura da
                    avaliação no sistema. Fique atento(a) <strong>ao relógio que vai aparecer na parte superior da
                      tela.</strong></li>
                  <li>Ao clicar em <strong>INICIAR A AVALIAÇÃO</strong>, o aluno(a) declara que é diplomado e apresentou
                    a
                    esta Instituição o
                    diploma de graduação superior, devidamente reconhecido pelo Ministério da Educação (MEC).</li>
                  <li>Ao final da avaliação, o aluno(a) deverá clicar na opção “<strong>FINALIZAR AVALIAÇÃO</strong>”.
                    Ao
                    selecionar essa
                    opção, o aluno(a) não poderá mais alterar/refazer a avaliação.</li>
                  <li>O sistema permite até 03 (três) tentativas para realizar a avaliação final do curso. Ao atingir
                    média
                    igual ou superior a 7,0 (sete), automaticamente será considerado aprovado(a) e serão encerradas as
                    demais tentativas.</li>
                  <li>Caso o aluno(a) não obtenha média igual ou superior a 7,0 (sete) em uma das 03 (três) tentativas,
                    o
                    aluno(a) poderá realizar uma avaliação substitutiva, mediante o pagamento de uma taxa acadêmica.
                  </li>
                  <li>Para os alunos que eventualmente tiveram a necessidade de realizar a avaliação substitutiva, o
                    sistema, ao processar o pagamento da taxa, liberará automaticamente uma nova avaliação, a qual o
                    aluno(a) terá apenas 01 (uma) tentativa para atingir média igual ou superior a 7,0 (sete). Caso não
                    atinja a média necessária na avaliação substitutiva, o aluno(a) deverá entrar em contato com a
                    Secretaria Acadêmica por meio do e-mail: contato@i9educacao.com.</li>
                  <li>A avaliação final ficará disponível no AVA, após a conclusão da Unidade de Ensino (UE) 12 (doze),
                    sendo que o prazo mínimo e máximo para integralização do curso, incluindo a realização/aprovação na
                    avaliação é 06 (seis) a 24 (vinte e quatro) meses, contados da data de liberação da 1ª (primeira)
                    aula
                    da UE 01.</li>
                  <li>Ao finalizar a avaliação e clicar em “<strong>ENVIAR AVALIAÇÃO</strong>”, o sistema irá apresentar
                    a
                    pontuação obtida
                    pelo aluno(a), bem como listar as questões em que obteve pontuação ou não. Para as questões em que o
                    aluno(a) não obteve pontuação, o sistema sinalizará a alternativa correta. A nota final da
                    avaliação,
                    também poderá ser consultada por meio da Secretaria Acadêmica, na aba “minhas notas”.</li>
                  <li><strong>RECURSO DA AVALIAÇÃO</strong>: caso o aluno queira entrar com recurso da avaliação, deverá
                    abrir um chamado via
                    contato@i9educacao.com, no qual será avaliado pela coordenação do curso. Se o recurso for provido, o
                    aluno receberá a pontuação devida.</li>
                </ol>
              </div>
            </div>
            <div class="col-md-12 tcc">
              <div class="orientacoes">
                <h4><strong>Trabalho de Conclusão de Curso (TCC)</strong></h4>
                <h5 style="margin-top: 10px;">Orientações:</h5>
                <p>A entrega do Trabalho de Conclusão de Curso (TCC) é OPCIONAL para os alunos de Pós-graduação em nível
                  de
                  lato sensu, conforme previso na Resolução CNE/CES nº 1, de 06 de abril de 2018. Para os alunos que
                  optarem
                  pela entrega do TCC, a Instituição irá disponibilizar uma Unidade de Ensino (UE) de Metodologia
                  Científica
                  para auxiliar no desenvolvimento do TCC, bem como o Manual.</p>
                <p style="font-size: 16px;"><strong>Caso você opte pela entrega do TCC, sinalize aqui:</strong></p>
                <div class="radio-tcc">
                  <input type="radio" name="desejoEntregarTcc" id="desejoEntregarTcc">
                  <label for="desejoEntregarTcc">Desejo entregar o TCC</label>
                  <input type="radio" name="naoDesejoEntregarTcc" id="naoDesejoEntregarTcc">
                  <label for="naoDesejoEntregarTcc">Não farei a entrega do TCC</label>
                </div>
                <!--<h5 class="mt-4">Este teste é meramente ilustrativo e não possui caráter de avaliação final para os cursos oferecidos pela Faculdade i9 Educação.</h5>-->
              </div>
            </div>
            <div class="col-md-12 checkboxs">
              <div :class="['ciente', { 'ciente-ativo': isCiente }]">
                <div :class="['check-ciente', { 'check-ciente-ativo': isCiente }]">
                  <input type="checkbox" name="estouCiente" id="estouCiente" v-model="isCiente">
                  <label for="estouCiente"><strong>Este teste é meramente ilustrativo e não possui caráter de avaliação
                      final para os cursos oferecidos pela Faculdade i9 Educação.</strong></label>
                </div>
              </div>
            </div>
            <div class="iniciar-avaliacao">
              <span :class="{ 'iniciar-avaliacao-ativo': isCiente }" @click="openModal">
                <img src="https://site-inove-bd2fd-homol.web.app/assets/icons/pen-paper.svg" alt="Prova png">
                INICIAR AVALIAÇÃO
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="currentPage === 'prova'">
        <ProvaComponent :timer="timer" :isPaused="isPaused" :isReviewMode="isReviewMode" :tentativas="tentativas"
          :maxTentativas="maxTentativas" @toggle-pause="togglePause" @pause-timer="pauseTimer"
          @reset-timer="resetTimer" />

      </div>
      <div v-else-if="currentPage === 'finalizado'" class="template-finalizado">
        <FinalizadoComponent v-if="currentPage === 'finalizado'" :tentativas="tentativas" :maxTentativas="maxTentativas"
          @increment-tentativas="incrementTentativas" @reset-timer="resetTimer" @review-prova="reviewProva" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ref, set, child, get } from "firebase/database";
import { database } from "./main";
import ProvaComponent from './components/ProvaComponent.vue';
import FinalizadoComponent from './components/FinalizadoComponent.vue';

export default {
  components: {
    ProvaComponent,
    FinalizadoComponent
  },
  data() {
    return {
      isCiente: false,
      isMenuOpen: false,
      currentPage: 'home',
      showModal: false,
      isLoading: false,
      error: null,
      form: {
        nome_completo: "",
        email: "",
        telefone: "",
      },
      userId: null,
      timer: 4 * 60 * 60, //Tempo inicial em segundos (4 horas)
      timerInterval: null, //Referência para o intervalo do timer
      isPaused: false,
      tentativas: 0,
      maxTentativas: 3,
      dropdowns: {
        posSocial: false,
        extensaoI9: false,
        faculdade: false,
      },
    };
  },
  created() {
    // Verifica se o usuário já está logado
    const savedUserId = localStorage.getItem("userId");
    if (savedUserId) {
      this.userId = savedUserId;
    } else {
      // Abre o modal automaticamente para cadastro no primeiro acesso
      this.showModal = true;
    }

    const savedTimer = parseInt(sessionStorage.getItem("timer"), 10);
    if (!isNaN(savedTimer)) {
      this.timer = savedTimer;
    }

    //Recuperar tentativas do Firebase
    if (this.userId) {
      const dbRef = ref(database, `users/${this.userId}/tentativas`);
      get(dbRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            this.tentativas = snapshot.val();
          } else {
            this.tentativas = 0; //Inicializa com 0 se não existir no Firebase
          }
        })
        .catch((error) => {
          console.error("Erro ao recuperar tentativas do Firebase:", error);
          this.tentativas = 0; //Fallback para 0 em caso de erro
        });
    } else {
      const savedTentativas = parseInt(localStorage.getItem("tentativas"), 10);
      if (!isNaN(savedTentativas)) {
        this.tentativas = savedTentativas;
      } else {
        this.tentativas = 0;
      }
    }

    const savedPage = sessionStorage.getItem("currentPage");
    if (savedPage) {
      this.currentPage = savedPage;

      // Bloqueia interações no modo de revisão
      if (savedPage === "prova" && this.isReviewMode) {
        this.preventReviewCheat();
      }
    }

    if (this.currentPage === "prova") {
      this.startTimer();
    }
  },
  methods: {
    saveTentativas() {
      if (this.userId) {
        const dbRef = ref(database, `users/${this.userId}`);
        set(child(dbRef, "tentativas"), this.tentativas)
          .then(() => {
            console.log("Tentativas salvas no Firebase com sucesso.");
          })
          .catch((error) => {
            console.error("Erro ao salvar tentativas no Firebase:", error);
          });
      }
    },
    incrementTentativas() {
      if (this.tentativas < this.maxTentativas) {
        this.tentativas++; // Incrementa localmente
        localStorage.setItem("tentativas", this.tentativas); //Salva localmente

        //Atualiza no Firebase
        if (this.userId) {
          const dbRef = ref(database, `users/${this.userId}`);
          set(child(dbRef, "tentativas"), this.tentativas)
            .then(() => {
              console.log("Tentativas atualizadas no Firebase com sucesso.");
            })
            .catch((error) => {
              console.error("Erro ao atualizar tentativas no Firebase:", error);
            });
        }
      }
    },
    openModal() {
      //Verifica se o usuário está logado
      if (this.userId) {
        this.startQuiz(); //Redireciona direto para a prova
      } else {
        this.showModal = true; //Abre o modal de cadastro
      }
    },
    closeModal() {
      this.showModal = false;
      this.error = null;
      this.form = {
        nome_completo: "",
        email: "",
        telefone: "",
      };
    },
    async registerUser() {
      this.isLoading = true;
      try {
        if (this.form.nome_completo.length < 5) {
          throw new Error("O nome completo deve ter pelo menos 5 caracteres.");
        }
        if (this.form.email.split("@")[0].length < 5) {
          throw new Error("O campo e-mail deve ter pelo menos 5 caracteres antes do '@'.");
        }

        //Sanitizar email
        const sanitizedEmail = this.form.email.replace(/\./g, "_");
        const dbRef = ref(database);

        //Verifica se o usuário já está cadastrado
        const userSnapshot = await get(child(dbRef, `users/${sanitizedEmail}`));
        if (userSnapshot.exists()) {
          //Usuário já existe, faz login
          this.userId = sanitizedEmail;
        } else {
          //Caso contrário, cria uma conta
          await set(ref(database, `users/${sanitizedEmail}`), {
            nome_completo: this.form.nome_completo,
            email: this.form.email,
            telefone: this.form.telefone,
            data_cadastro: new Date().toISOString(),
          });
          this.userId = sanitizedEmail; //Define o usuário como logado
        }

        //Salva o estado de login no localStorage
        localStorage.setItem("userId", this.userId);

        //Enviar dados para o RD Station
        await this.sendDataToRDStation(this.form);


        this.error = null;
        this.closeModal(); //Fecha o modal após cadastro
        //this.startQuiz(); //Inicia a prova
      } catch (err) {
        this.error = err.message;
      } finally {
        this.isLoading = false;
      }
    },
    async sendDataToRDStation(user) {
      const data = {
        event_type: "CONVERSION",
        event_family: "CDP",
        payload: {
          conversion_identifier: "Acesso-TesteConhecimento",
          email: user.email,
          name: user.nome_completo,
          cf_whatsapp: user.telefone,
        },
      };

      try {
        const response = await axios.post(
          "https://api.rd.services/platform/conversions?api_key=lFyvpZxKoccjZNBBaZMIlUCRHOgSzseJgWYX",
          data
        );
        console.log("Dados enviados para RD Station:", response.data);
      } catch (error) {
        console.error(`Erro ao enviar dados para RD Station: ${error}`);
      }
    },
    startQuiz() {
      if (this.tentativas < this.maxTentativas) {
        this.tentativas++;
        localStorage.setItem("tentativas", this.tentativas); //Salva localmente

        //Salvar as tentativas no Firebase
        this.saveTentativas();

        this.currentPage = "prova"; //Altera para o componente da prova
        sessionStorage.setItem("currentPage", "prova");
        this.startTimer(); // Inicia o timer
      } else {
        alert("Você já atingiu o limite máximo de tentativas.");
      }
    },
    startTimer() {
      if (this.timerInterval) clearInterval(this.timerInterval); //Evita múltiplos timers
      this.timerInterval = setInterval(() => {
        if (!this.isPaused && this.timer > 0) {
          this.timer--;
          sessionStorage.setItem('timer', this.timer); //Salva o estado do timer
        } else if (this.timer <= 0) {
          clearInterval(this.timerInterval); //Para o timer ao atingir 0
          alert('Tempo esgotado!');
        }
      }, 1000);
    },
    togglePause() {
      this.isPaused ? this.resumeTimer() : this.pauseTimer();
    },
    finalizarProva() {
      clearInterval(this.timerInterval); //Limpa o intervalo do timer
      sessionStorage.removeItem('currentPage'); //Limpa o estado ao finalizar a prova
      this.currentPage = 'home'; //Volta para a página inicial ou para outro estado
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    formatTime(seconds) {
      const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
      const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
      const s = String(seconds % 60).padStart(2, '0');
      return `${h}:${m}:${s}`;
    },
    reiniciarTimer() {
      this.timer = 4 * 60 * 60; // Reseta o timer para o valor inicial
      this.startTimer(); // Reinicia o timer
    },
    resetTimer() {
      this.timer = 4 * 60 * 60; // Define o timer para 4 horas (ou o valor inicial que desejar)
      this.isPaused = false; // Garante que o timer não esteja pausado
      this.startTimer(); // Reinicia o timer
    },
    pauseTimer() {
      this.isPaused = true; // Marca como pausado
      clearInterval(this.timerInterval); // Para o intervalo do timer
      console.log("Timer pausado.");
    },
    resumeTimer() {
      this.isPaused = false;
      this.startTimer();
    },
    tentarNovamente() {
      if (this.tentativas < this.maxTentativas) {
        sessionStorage.setItem("currentPage", "prova"); // Define a página atual como 'prova'
        sessionStorage.removeItem("resultadoProva"); // Limpa o resultado da prova
        this.$emit("reset-timer"); // Emite o evento para resetar o timer
        this.$parent.currentPage = "prova"; // Altera a página no App.vue
      } else {
        alert("Você já atingiu o limite máximo de tentativas.");
      }
    },
    conferirProva() {
      this.$emit("review-prova"); // Emite um evento para o App.vue
      this.$parent.currentPage = "prova"; // Altera para a página de prova no App.vue
    },
    reviewProva() {
      this.currentPage = "prova"; // Volta para a página de prova
      sessionStorage.setItem("currentPage", "prova"); // Salva a página atual
      this.isPaused = true; // Pausa o timer durante a revisão
      this.isReviewMode = true; // Ativa o modo de revisão
    },
    toggleDropdown(menu) {
      this.dropdowns[menu] = !this.dropdowns[menu];
    },
    showDropdown(menu) {
      if (window.innerWidth > 768) {
        this.dropdowns[menu] = true;
      }
    },
    hideDropdown(menu) {
      if (window.innerWidth > 768) {
        this.dropdowns[menu] = false;
      }

    },
  },
  beforeUnmount() {
    clearInterval(this.timerInterval); //Limpa o intervalo ao destruir o componente
  },

}
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  text-align: center;
}

.modal .input-group {
  margin-bottom: 15px;
  text-align: left;
}

.modal .input-group label {
  display: block;
  margin-bottom: 5px;
}

.modal .input-group input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.input-group-modal {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.login-form h2 {
  font-size: 26px;
  color: #212236;
}

.modal .actions {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.modal .actions button {
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.modal .actions button:first-child {
  background: #16f9b9;
  color: white;
}

.modal .actions button:last-child {
  background: #ccc;
}

.error {
  color: red;
  margin-top: 10px;
}

html {
  background: #e2e2e2;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

:root {
  --primary-green: #a5e9d6;
  --primary-strong-green: #16f9b9;
}

#app {
  font-family: Almarai, sans-serif;
  background: #e2e2e2;
}

.suporte {
  background: #fff;
  padding: 5px;
}

.suporte a {
  text-decoration: none;
  color: #000;
  font-size: 14px;
  margin-right: 10px;
}

.suporte a img {
  margin-right: 10px;
  width: 15px;
  height: 15px;
}

.suporte-container {
  display: flex;
  align-items: center;
  justify-content: end;
}

.navbar {
  background: #181818;
}

.nav-itens {
  display: flex;
}

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: auto;
}

.hamburger .bar {
  height: 2px;
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
}

.nav-itens a {
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  margin-right: 10px
}

.nav-itens a:hover{
  border-bottom: 1px solid #16f9b9;
}

.nav-item {
  position: relative;
}

.nav-item a {
  text-decoration: none;
  color: white;
  padding: 10px;
}

.nav-item .arrow {
  margin-left: 5px;
}

.nav-item .arrow-down {
  transform: rotate(180deg);
}

.submenu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  color: black;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.submenu a {
  display: block;
  padding: 10px 25px;
  text-decoration: none;
  color: #333;
  font-weight: bold;
  text-align: center;
  font-size: 13px;
  margin: auto
}

.submenu a:hover {
  background: #f5f5f5;
  border-radius: 5px;
}

.nav-itens .nav-item:hover .submenu {
  display: block;
}

.avaliacao-final {
  background: var(--primary-green);
  height: 90px;
  display: flex;
  align-items: center;
  margin-bottom: 4%;
}

.avaliacao-final p {
  font-size: 24px;
  color: #000;
  margin: 0;
}

.timer span {
  display: flex;
  align-items: center;
}

.duracao-prova {
  background: #16f9b9;
  font-weight: bold;
  padding: 3px;
  padding-inline: 20px;
  border-radius: 8px;
  margin-left: 5px;
}

.informativo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  margin-top: -20px;
  font-weight: bold;
}

.video {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  height: 400px;
}

.video iframe {
  border-radius: 8px;
  width: 100%;
  height: 100%;
}

.leia-atentamente {
  background: var(--primary-strong-green);
  padding: 8px;
  padding-inline: 15px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leia-atentamente p {
  margin: auto;
  margin-left: 10px;
  font-size: 15px;
}

.leia-atentamente ol li {
  font-size: 15px;
}

.informacoes-prova {
  margin-top: 30px;
  height: 300px;
  overflow-y: auto;
}

.orientacoes {
  display: none;
  margin-top: 5%;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  padding-inline: 30px;
  position: relative;
}

.orientacoes h4 {
  background: var(--primary-strong-green);
  padding: 15px;
  font-size: 16px;
  position: absolute;
  border-radius: 8px;
  top: -30px;
  left: 0;
}

.orientacoes h5 {
  font-size: 14px;
  color: #212529;
  font-weight: bold;
}

.orientacoes p {
  font-size: 14px;
  margin-bottom: 10px;
}

.orientacoes label {
  margin-left: 15px;
}

input#naoDesejoEntregarTcc {
  margin-left: 15px;
}

.ciente {
  background: #ffe70f;
  margin-top: 3% !important;
  border-radius: 8px;
  height: 124px;
  display: flex;
  align-items: center;
  padding: 15px;
}

.ciente-ativo {
  background-color: #16f9b9;
}

.check-ciente {
  border: 1px solid red;
  border-radius: 10px;
  background: #fff387;
  display: flex;
  padding: 15px;
  width: 100%;
}

.check-ciente-ativo {
  background: #d0fef1;
}

.check-ciente label {
  margin-left: 10px;
}

.iniciar-avaliacao {
  font-weight: bold;
  color: #000;
  font-size: 20px;
  padding: 15px;
  margin-top: 3% !important;
  margin-bottom: 5%;
  position: relative;
  display: flex;
  justify-content: end;
  align-items: center;
}

.iniciar-avaliacao span {
  background: #d9d9d9;
  padding: 30px;
  cursor: pointer;
  border-radius: 8px;
}

.iniciar-avaliacao-ativo {
  background-color: #16f9b9 !important;
}

.iniciar-avaliacao img {
  margin-right: 10px;
}

.template-finalizado {
  margin-top: -40px;
  margin-bottom: 40px;
}

.modal-login {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  z-index: 9;
}

.login-form {
  background: #fff;
  border-radius: 8px;
  width: 650px;
  padding: 40px;
  text-align: center;
  color: #333;
}

.login-form h1 {
  font-size: 28px;
}

.login-form strong {
  background-color: #b812ff;
  color: #fff;
}

.error-login {
  color: #ff0c0c;
  font-size: 16px;
  border-radius: 10px;
  border: none;
  margin: 10px 0 -23px 0;
}

.login-form form {
  margin-top: 4%;
}

.login-form input {
  background: #f0f0f0;
  color: #929292;
  border: none;
  border-radius: 10px;
  padding: 15px;
  width: 100%;
}

.login-form button {
  background-color: #16f9b9;
  border: none;
  color: #251D59;
  font-size: 24px;
  padding: 10px;
  padding-inline: 30px;
  border-radius: 10px;
  margin-top: 8%;
  font-weight: bold;
  font-size: 20px;
  margin-inline: 5px;
  width: 45%;
}

.login-form button:hover {
  background-color: #69f9de;
}

/*
.login-form button:first-child {
  background: #f76868;
  color: #fff;
}

.login-form button:first-child:hover {
  background: #ff8a8a;

}*/

.button-inputs {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.visu-regras {
  background: none !important;
  color: #333 !important;
  font-size: 20px !important;
  text-align: center;
  margin-top: 5px !important;
  margin: auto;
}

.visu-regras:hover {
  color: #6b6b6b !important;
}

.login-form a {
  font-weight: bold;
  font-size: 17px;
  color: #333;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.login-form a:hover {
  color: #767676;
}

#nome_completo {
  width: 100%;
}

#email {
  margin-right: 15px;
}

#telefone {
  margin-left: 15px;
}

.input-group-1 {
  margin-bottom: 27px;
}

.input-group-itens {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media(max-width:768px) {
  .nav-itens {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 90px;
    left: 0;
    width: 100%;
    background-color: #202135;
    z-index: 1;
    text-align: center;
  }

  .nav-itens-active {
    display: flex;
    z-index: 99;
  }

  .nav-itens a {
    border-bottom: 1px solid #161826;
    padding: 5px;
  }

  .submenu {
    position: static;
    display: none;
    background: #202135;
  }

  .nav-item .submenu {
    display: block;
    background: #2b2c42;
  }

  .nav-item a {
    color: white;
    background: none;
    display: block;
  }

  .hamburger {
    display: flex;
  }

  .timer {
    position: absolute;
    top: 107px;
    right: 10px;
    font-size: 12px;
  }

  .timer img {
    display: none;
  }

  .avaliacao-final p {
    text-align: center;
  }

  .pag-home {
    margin-top: 80px;
  }

  .informativo {
    font-size: 14px;
  }

  .video {
    height: 250px;
    padding: 10px;
  }

  .orientacoes-atentamente {
    margin-top: 5% !important;
  }

  .leia-atentamente p {
    font-weight: bold;
    font-size: 14px;
  }

  .tcc {
    margin-top: 5% !important;
  }

  .orientacoes{
    margin-top: 10%;
  }

  .orientacoes h4 {
    left: 50%;
    transform: translateX(-50%);
    width: 91%;
  }

  .radio-tcc{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
  }

  .actions{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .checkboxs {
    margin-top: 5% !important;
  }

  .ciente {
    height: auto;
  }

  .check-ciente{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .check-ciente label{
    font-size: 14px;
  }

  .template-finalizado {
    margin-top: 20px;
  }

  .login-form {
    width: 96%;
  }

  .login-form h2 {
    font-size: 21px;
  }

  .login-form button {
    width: 100%;
  }

  .input-group-modal{
    flex-direction: column;
  }

  #email {
    margin-right: 0;
  }

  #telefone {
    margin-left: 0px;
    margin-top: 20px;
  }
}
</style>
